import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import GetProductContext, { GetProductContextProps } from "@store/Components/Common/ProductContext/GetProductContext";
import React, { FC } from "react";

interface OwnProps {
    product?: ProductModel;
}

type Props = OwnProps & GetProductContextProps;

const GetOptionalProductContext: FC<Props> = ({ product, children, ...otherProps }) => {
    if (!product) {
        return <>{children}</>;
    }

    return (
        <GetProductContext product={product as ProductModel} {...otherProps}>
            {children}
        </GetProductContext>
    );
};

export default GetOptionalProductContext;
